import { Component, Input, inject } from '@angular/core';
import {ProjectReferenceSearchResponse} from '../../models/project-reference-search-response';
import {AuthService} from '../../services/auth.service';
import {Router} from '@angular/router';
import {Authority} from '../../models/authority';

@Component({
    selector: 'app-project-reference-table',
    templateUrl: './project-reference-table.component.html',
    standalone: false
})
export class ProjectReferenceTableComponent {
    private authService = inject<AuthService>('AuthService' as any);
    private router = inject(Router);

    @Input() projectReferences: ProjectReferenceSearchResponse[] | null = [];

    authorities = Authority;

    async tableRowSelect(ref: ProjectReferenceSearchResponse): Promise<void> {
        await this.router.navigate(['project-references', ref.id]);
    }

    trackByFn(index: number, ref: ProjectReferenceSearchResponse) {
        return ref.id
    }
}
